import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import king from "../photo/KING 4.jpg";
import queen from "../photo/QUEEN 2.jpg";
import suite from "../photo/SUITE 5.jpg";
import ada from "../photo/KING 1.jpg";
import banner from "../photo/2ND FLOOR LOBBY.jpg";
import { Users, Bed, Check, Maximize } from "lucide-react";

const Booking_engine_URL = process.env.REACT_APP_BOOKING_URL;

const rooms = [
  {
    id: "king",
    name: "Non-Smoking King",
    image: king,
    description: "Spacious room featuring one king-size bed, perfect for couples seeking comfort and relaxation.",
    price: 99,
    capacity: 2,
    beds: "1 King Bed",
    
    amenities: ["Smoke-Free Room","Free WiFi", "Flat-screen TV", "Mini Fridge", "Coffee Maker", "Microwave", "Air Conditioning"]
  },
  {
    id: "queens",
    name: "Non-Smoking 2 Queens",
    image: queen,
    description: "Ideal for families or groups, this room offers two comfortable queen-size beds.",
    price: 119,
    capacity: 4,
    beds: "2 Queen Beds",
   
    amenities: ["Smoke-Free Room","Free WiFi", "Flat-screen TV", "Mini Fridge", "Coffee Maker", "Microwave", "Air Conditioning"]
  },
  {
    id: "suite",
    name: "Non-Smoking 2 Queen Suite",
    image: suite,
    description: "Ideal for families or groups, this spacious suite features two comfortable queen-size beds, a cozy living area, a fully equipped kitchenette, and a modern bathroom for a relaxing stay.",
    price: 109,
    capacity: 4,
    beds: "2 Queen Bed",
    
    amenities: ["Smoke-Free Room","Free WiFi", "Flat-screen TV", "Mini Fridge","Coffee Maker", "Microwave", "Air Conditioning","Work Desk with Chair","Electric Cooktop/Stove","Breakfast Bar with Seating"]
  },
    {
    
    id: "ada",
    name: "Non-Smoking King ADA",
    image: ada,
    description: "Fully accessible room with mobility features, roll-in shower, and grab bars for guest comfort.",
    price: 109,
    capacity: 2,
    beds: "1 King Bed",
  
    amenities: ["ADA Accessible", "Roll-in Shower", "Grab Bars", "Free WiFi", "Flat-screen TV", "Mini Fridge"]
  
  }
];

export default function Rooms() {
  return (
    <div data-testid="rooms-page">
      <Helmet>
        <title>Rooms & Suites | Destin Inn & Suites - Destin, FL</title>
        <meta name="description" content="Browse our comfortable rooms at Destin Inn & Suites. Choose from King rooms, Double Queens, and ADA accessible options starting at $99/night." />
      </Helmet>

      {/* Hero Section */}
      <section className="relative h-[40vh] min-h-[300px] overflow-hidden" data-testid="rooms-hero">
        <img
          src={banner}
          alt="Hotel Rooms"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <p className="font-accent text-2xl text-accent mb-2">Our Accommodations</p>
            <h1 className="font-heading text-4xl md:text-6xl font-bold">Rooms & Suites</h1>
          </div>
        </div>
      </section>

      {/* Rooms Section */}
      <section className="py-20 md:py-28" data-testid="rooms-list">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-gray-900 mb-4">
              Choose Your Perfect Room
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Each of our rooms is designed with your comfort in mind, featuring modern amenities and coastal-inspired decor.
            </p>
          </div>

          <div className="space-y-12">
            {rooms.map((room, index) => (
              <div
                key={room.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
                  index % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
                data-testid={`room-card-${room.id}`}
              >
                {/* Image */}
                <div className={`img-zoom rounded-2xl overflow-hidden shadow-lg ${index % 2 === 1 ? "lg:order-2" : ""}`}>
                  <img
                    src={room.image}
                    alt={room.name}
                    className="w-full h-[300px] md:h-[400px] object-cover"
                  />
                </div>

                {/* Details */}
                <div className={`${index % 2 === 1 ? "lg:order-1" : ""}`}>
                  {/* <div className="flex items-center gap-3 mb-4">
                    <span className="px-4 py-1 rounded-full bg-accent/10 text-accent text-sm font-medium">
                      From ${room.price}/night
                    </span>
                  </div> */}
                  <h3 className="font-heading text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
                    {room.name}
                  </h3>
                  <p className="text-gray-600 text-lg mb-6">{room.description}</p>

                  {/* Room Info */}
                  <div className="flex flex-wrap gap-6 mb-6">
                    <div className="flex items-center gap-2 text-gray-700">
                      <Users className="w-5 h-5 text-primary" />
                      <span>Up to {room.capacity} guests</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700">
                      <Bed className="w-5 h-5 text-primary" />
                      <span>{room.beds}</span>
                    </div>
                    {/* <div className="flex items-center gap-2 text-gray-700">
                      <Maximize className="w-5 h-5 text-primary" />
                      <span>{room.size}</span>
                    </div> */}
                  </div>

                  {/* Amenities */}
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {room.amenities.map((amenity, i) => (
                      <div key={i} className="flex items-center gap-2 text-gray-600">
                        <Check className="w-4 h-4 text-accent" />
                        <span className="text-sm">{amenity}</span>
                      </div>
                    ))}
                  </div>

                  {/* CTA */}
                  <Link 
                      to="https://reservation.asiwebres.com/SearchAvailability.aspx?id=fe8081bb0f084e97a77465b543125857"
                      // data-testid={`home-read-more-${room.id}`}
                    >
                      <Button 
                        variant="outline" 
                        className="border-2 border-primary text-primary hover:bg-primary hover:text-white rounded-md px-6 py-2.5 font-medium transition-all duration-300"
                      >
                        Book Now
                      
                      </Button>
                    </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-16 bg-secondary" data-testid="rooms-info">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <h4 className="font-heading text-xl font-semibold text-gray-900 mb-2">Check-in Time</h4>
              <p className="text-gray-600">4:00 PM</p>
            </div>
            <div>
              <h4 className="font-heading text-xl font-semibold text-gray-900 mb-2">Check-out Time</h4>
              <p className="text-gray-600">11:00 AM</p>
            </div>
            <div>
              <h4 className="font-heading text-xl font-semibold text-gray-900 mb-2">Questions?</h4>
              <p className="text-gray-600">Call (850) 650-2236</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
